export const CRMPayment = [
    {
      "payment_no": 1659,
      "invoice_no": "INV-2025/1377",
      "payment_mode": "Bank",
      "transaction_id": "Axis Bank",
      "customer": "Gayathri Milk Dairy Pvt Ltd",
      "amount": "Rs.8,850.00",
      "date": "21/03/2025"
    },
    {
      "payment_no": 1658,
      "invoice_no": "INV-2025/1370",
      "payment_mode": "Bank",
      "transaction_id": "Axis Bank",
      "customer": "One Rise Vacations LLP",
      "amount": "Rs.12,980.00",
      "date": "12/03/2025"
    },
    {
      "payment_no": 1657,
      "invoice_no": "INV-2025/1368",
      "payment_mode": "G-Pay",
      "transaction_id": "HDFC Bank",
      "customer": "Tomatoes Super Market (Sai Manikanta)",
      "amount": "Rs.1,534.00",
      "date": "07/03/2025"
    },
    {
      "payment_no": 1656,
      "invoice_no": "INV-2025/1366",
      "payment_mode": "G-Pay",
      "transaction_id": "HDFC Bank",
      "customer": "Avakaaya.com",
      "amount": "Rs.5,710.00",
      "date": "11/03/2025"
    },
    {
      "payment_no": 1655,
      "invoice_no": "INV-2025/1366",
      "payment_mode": "G-Pay",
      "transaction_id": "HDFC Bank",
      "customer": "Avakaaya.com",
      "amount": "Rs.5,500.00",
      "date": "05/03/2025"
    },
    {
      "payment_no": 1654,
      "invoice_no": "INV-2025/1365",
      "payment_mode": "Bank",
      "transaction_id": "HDFC Bank",
      "customer": "Einstein Child Therapy Centre",
      "amount": "Rs.8,850.00",
      "date": "28/02/2025"
    },
    {
      "payment_no": 1653,
      "invoice_no": "INV-2025/1364",
      "payment_mode": "Bank",
      "transaction_id": "Axis Bank",
      "customer": "Dr Marins Personalized Child Therapy",
      "amount": "Rs.23,010.00",
      "date": "28/02/2025"
    }
  ]
  